import React from "react";
import "../../assets/css/address-group.css";
import { Say } from "../../languages";

type AddressGroupProps = {
  children?: React.ReactNode;
  visible: boolean;
};

export function AddressGroup(props: AddressGroupProps) {
  const { children, visible = false } = props;
  // When hiding the object, we want it to be avaialable for browser auto-fill.
  // Properties like display: none; or visibility: hidden; will prevent the browser from auto-filling the form.
  const style: React.CSSProperties = visible
    ? { border: "none" }
    : { left: "-9999px", height: 0, position: "absolute" };

  return (
    <fieldset className="billing-address--manual is-required" style={style}>
      <legend className="billing-address__legend control-label">
        <Say phrase="payment_step.billing_address_heading" /> <sup>*</sup>
      </legend>
      {children}
    </fieldset>
  );
}

export default AddressGroup;
